import { render } from "./FlightDetailsCard.vue?vue&type=template&id=4b4ca77c&scoped=true"
import script from "./FlightDetailsCard.vue?vue&type=script&lang=js"
export * from "./FlightDetailsCard.vue?vue&type=script&lang=js"

import "./FlightDetailsCard.vue?vue&type=style&index=0&id=4b4ca77c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4ca77c"]])

export default __exports__